import { League } from "../../../contracts";

export const filterLeagues = (leagues: League[], sportId: string): League[] => {
    return leagues.filter(league => league.sportId === sportId);
}